import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';
import { CitationMetadata, CitationLabels } from './Citation.types';

interface CitationContextValue {
  citations: CitationMetadata[];
  selectedCitation: CitationMetadata | null;
  isModalOpen: boolean;
  labels?: CitationLabels;
  openCitation: (citationId: number | string) => void;
  closeCitation: () => void;
}

const CitationContext = createContext<CitationContextValue | undefined>(undefined);

interface CitationProviderProps {
  citations: CitationMetadata[];
  labels?: CitationLabels;
  children: ReactNode;
}

export const CitationProvider: React.FC<CitationProviderProps> = ({
  citations,
  labels,
  children,
}) => {
  const [selectedCitation, setSelectedCitation] = useState<CitationMetadata | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openCitation = (citationId: number | string) => {
    // Comparación que funciona con number o string
    const citation = citations.find((c) => String(c.segment_id) === String(citationId));
    if (citation) {
      setSelectedCitation(citation);
      setIsModalOpen(true);
    }
  };

  const closeCitation = () => {
    setIsModalOpen(false);
    setSelectedCitation(null);
  };

  const value = useMemo(
    () => ({
      citations,
      selectedCitation,
      isModalOpen,
      labels,
      openCitation,
      closeCitation,
    }),
    [citations, selectedCitation, isModalOpen, labels]
  );

  return <CitationContext.Provider value={value}>{children}</CitationContext.Provider>;
};

export const useCitation = (): CitationContextValue => {
  const context = useContext(CitationContext);
  if (!context) {
    throw new Error('useCitation must be used within a CitationProvider');
  }
  return context;
};

